import { db } from '../firebase'; 
import { 
  collection, 
  getDocs, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  doc, 
  query, 
  orderBy, 
  serverTimestamp 
} from 'firebase/firestore';

const ENGINEER_COLLECTION = 'E2B_ENGINEERS';

export const engineerService = {
  // 1. 클라우드에서 엔지니어 목록 가져오기
  getEngineers: async () => {
    try {
      const q = query(collection(db, ENGINEER_COLLECTION), orderBy('createdAt', 'desc'));
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
    } catch (e) {
      console.error("엔지니어 로드 실패:", e);
      return [];
    }
  },

  // 2. 신규 엔지니어 저장
  saveEngineer: async (data) => {
    try {
      const docRef = await addDoc(collection(db, ENGINEER_COLLECTION), {
        ...data,
        createdAt: serverTimestamp()
      });
      return docRef.id;
    } catch (e) {
      console.error("엔지니어 저장 실패:", e);
      throw e;
    }
  },

  // 3. 기존 엔지니어 정보 수정
  updateEngineer: async (id, data) => {
    try {
      const docRef = doc(db, ENGINEER_COLLECTION, id);
      const { id: _, ...updateData } = data; // id 제외하고 업데이트
      await updateDoc(docRef, {
        ...updateData,
        updatedAt: serverTimestamp()
      });
    } catch (e) {
      console.error("엔지니어 수정 실패:", e);
      throw e;
    }
  },

  // 4. 엔지니어 삭제
  deleteEngineer: async (id) => {
    try {
      await deleteDoc(doc(db, ENGINEER_COLLECTION, id));
    } catch (e) {
      console.error("엔지니어 삭제 실패:", e);
    }
  }
};